import * as Sentry from '@sentry/angular';

import { environment } from '@environments/environment';

export function initSentry(): void {
  if (!environment.sentry) {
    return;
  }

  Sentry.init({
    dsn: environment.sentry.dsn,
    release: 'dev-b8866a24ec4182b5f0c3b413163cf83cf2572068',
    environment: environment.sentry.environment,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    tracesSampleRate: 0.2,
    tracePropagationTargets: ['localhost', environment.apiUrl],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
